// src/components/common/MedalNotification.jsx
import React, { useEffect, useState } from 'react';
import confetti from 'canvas-confetti';
import './MedalNotification.css';

export function MedalNotification() {
  const [medals, setMedals] = useState([]);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      const newMedals = e.detail.medals;
      setMedals(newMedals);
      setVisible(true);
      confetti({
        particleCount: 150,
        spread: 80,
        origin: { y: 0.5 },
        colors: ['#fbbf24', '#f472b6', '#34d399', '#60a5fa', '#a78bfa']
      });
      setTimeout(() => {
        setVisible(false);
        setTimeout(() => setMedals([]), 300);
      }, 5000);
    };

    window.addEventListener('medalUnlocked', handler);
    return () => window.removeEventListener('medalUnlocked', handler);
  }, []);

  if (!visible || medals.length === 0) return null;

  return (
    <div className={`medal-notification-overlay ${visible ? 'active' : ''}`}>
      <div className="medal-popup">
        <div className="medal-popup-header">
          <span className="trophy-icon">🏆</span>
          <h2>مدال جدید دریافت کردی!</h2>
        </div>
        <div className="medal-list">
          {medals.map(m => (
            <div key={m.id} className="medal-item">
              <span className="medal-icon">{m.icon}</span>
              <div className="medal-info">
                <span className="medal-name">{m.name}</span>
                <span className="medal-desc">{m.description}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="medal-popup-footer">
          <span>✨ به تلاشت ادامه بده!</span>
        </div>
      </div>
    </div>
  );
}